<template>
  <div class="wf-page">
    <div class="wf-page-head">
      <el-input v-model="query.condition.flowName" size="small" placeholder="搜索流程名称" style="width: 200px"
                clearable @keyup.enter.native="reload" />
      <el-select v-model="query.condition.status" size="small" placeholder="状态" style="width: 120px" clearable>
        <el-option label="草稿" :value="0" />
        <el-option label="已发布" :value="1" />
        <el-option label="停用" :value="2" />
      </el-select>
      <el-select v-model="query.condition.category" size="small" placeholder="分类" style="width: 140px" clearable filterable>
        <el-option v-for="c in categories" :key="c" :label="c" :value="c" />
      </el-select>
      <el-button size="small" icon="el-icon-search" @click="reload">查询</el-button>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openDesigner(null)">新建流程</el-button>
    </div>

    <el-table :data="list" v-loading="loading" size="small" border style="width: 100%">
      <el-table-column prop="flowName" label="流程名称" min-width="150" />
      <el-table-column prop="flowKey" label="流程标识" min-width="140" />
      <el-table-column prop="category" label="分类" width="100" />
      <el-table-column prop="subCategory" label="二级分类" width="110" />
      <el-table-column label="绑定表单" min-width="130">
        <template slot-scope="{ row }">{{ formName(row.formId) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(row.status)">{{ statusText(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="version" label="版本" width="70" align="center" />
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="openDesigner(row.id)">设计</el-button>
          <el-button type="text" size="mini" v-if="row.status !== 1" @click="publish(row)">发布</el-button>
          <el-button type="text" size="mini" v-if="row.status === 1" @click="disable(row)">停用</el-button>
          <el-button type="text" size="mini" @click="copy(row)">复制</el-button>
          <el-button type="text" size="mini" style="color:#F56C6C" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="wf-pager" background layout="total, prev, pager, next"
                   :total="total" :current-page="query.page" :page-size="query.limit" @current-change="onPage" />

    <el-dialog :title="editingId ? '编辑流程' : '新建流程'" :visible.sync="designerVisible" fullscreen
               :close-on-click-modal="false" append-to-body>
      <WflowFlowDesigner v-if="designerVisible" :flow-id="editingId" @saved="onSaved" @cancel="designerVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import WflowFlowDesigner from './WflowFlowDesigner.vue'
import { listFlow, listCategories, publishFlow, disableFlow, copyFlow, deleteFlow } from '@/api/wflow/flow'
import { listAllForm } from '@/api/wflow/form'

export default {
  name: 'WflowFlowList',
  components: { WflowFlowDesigner },
  data() {
    return {
      loading: false, list: [], total: 0, forms: [], categories: [],
      query: { page: 1, limit: 10, condition: { flowName: '', status: null, category: null } },
      designerVisible: false, editingId: null
    }
  },
  created() {
    this.loadForms()
    this.loadCategories()
    this.reload()
  },
  methods: {
    loadForms() {
      listAllForm().then(res => { if (res && res.code === 200) this.forms = res.data || [] })
    },
    loadCategories() {
      listCategories().then(res => { if (res && res.code === 200) this.categories = res.data || [] })
    },
    formName(id) {
      const f = this.forms.find(x => x.id === id)
      return f ? f.formName : '—'
    },
    reload() { this.query.page = 1; this.load() },
    load() {
      this.loading = true
      listFlow(this.query).then(res => {
        this.loading = false
        if (res && res.code === 200 && res.data) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        }
      }).catch(() => { this.loading = false })
    },
    onPage(p) { this.query.page = p; this.load() },
    openDesigner(id) { this.editingId = id; this.designerVisible = true },
    onSaved() { this.designerVisible = false; this.load() },
    publish(row) {
      this.$confirm('确认发布流程「' + row.flowName + '」？发布后可被发起。', '提示', { type: 'warning' })
        .then(() => publishFlow(row.id))
        .then(res => { if (res && res.code === 200) { this.$message.success('已发布'); this.load() } })
        .catch(() => {})
    },
    disable(row) {
      this.$confirm('确认停用流程「' + row.flowName + '」？不影响在途实例。', '提示', { type: 'warning' })
        .then(() => disableFlow(row.id))
        .then(res => { if (res && res.code === 200) { this.$message.success('已停用'); this.load() } })
        .catch(() => {})
    },
    copy(row) {
      copyFlow(row.id).then(res => { if (res && res.code === 200) { this.$message.success('已复制'); this.load() } })
    },
    remove(row) {
      this.$confirm('确认删除流程「' + row.flowName + '」？', '提示', { type: 'warning' })
        .then(() => deleteFlow(row.id))
        .then(res => { if (res && res.code === 200) { this.$message.success('已删除'); this.load() } })
        .catch(() => {})
    },
    statusText(s) { return { 0: '草稿', 1: '已发布', 2: '停用' }[s] || '草稿' },
    statusType(s) { return { 0: 'info', 1: 'success', 2: 'warning' }[s] || 'info' }
  }
}
</script>

<style scoped>
.wf-page { padding: 4px; }
.wf-page-head { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.wf-pager { margin-top: 12px; text-align: right; }
</style>
